import type { BaseTenantId } from "@tilli-internal/tenant-data";

/** The custom URL scheme the mobile app registers (`scheme` in apps/tx-react-native/app.config.js). */
export const MOBILE_APP_SCHEME = "tillix";

/**
 * Marks a magic link the mobile app asked for. The app requests its link with
 * `callbackURL: "/dashboard?source=app"`; because only the app sends it, a link carrying it proves the
 * app is installed somewhere, which is the one thing a web page cannot otherwise find out.
 */
export const APP_SOURCE_PARAM = "source";
export const APP_SOURCE_VALUE = "app";

export interface MobileAppStoreLinks {
  ios?: string;
  android?: string;
}

/**
 * Public store listings, per tenant and platform. The install banner only shows on a platform that has
 * a link here, so it stays hidden until the app is publicly listed: a TestFlight or Play testing-track
 * build cannot be offered to the public.
 */
export const MOBILE_APP_STORE_LINKS: Partial<
  Record<BaseTenantId, MobileAppStoreLinks>
> = {
  hc: {},
};

/** How long the install banner stays hidden after it is dismissed or followed. */
export const APP_BANNER_SNOOZE_DAYS = 90;
